import React from 'react';
import { Link } from 'react-router-dom';
export function HomeNavLogo() {
  return <Link to="/" className="flex items-center gap-3 group" data-id="element-1180">
      <div className="relative w-16 h-16 overflow-hidden rounded-full border-2 border-[#00D4FF] bg-black" data-id="element-1181">
        <img src="https://cdn.magicpatterns.com/uploads/fmBXjQm2BPtC5bTSRKvwCz/walkerlogo-gigapixel-cgi-3600w.png" alt="Walker's Martial Arts Logo" className="w-full h-full object-cover" data-id="element-1182" />
      </div>
      <div className="flex flex-col" data-id="element-1183">
        <span className="text-white font-bold text-xl leading-none tracking-wide uppercase" data-id="element-1184">
          Walker's
        </span>
        <span className="text-[#00D4FF] font-bold text-base leading-none tracking-wider uppercase" data-id="element-1185">
          Martial Arts
        </span>
      </div>
    </Link>;
}